import {inject, Injectable} from '@angular/core';
import {WA_LOCAL_STORAGE} from '@ng-web-apis/common';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private readonly storage = inject<Storage | null>(WA_LOCAL_STORAGE);

  public setItem<T = unknown>(key: string, value: T): void {
    if (!this.storage) {
      return;
    }

    try {
      const jsonValue = JSON.stringify(value);
      this.storage.setItem(key, jsonValue);
    } catch (error) {
      console.error('Error saving to localStorage: ', error);
    }
  }

  public getItem<T>(key: string): T | null {
    if (!this.storage) {
      return null;
    }

    try {
      const value = this.storage.getItem(key);
      return value ? (JSON.parse(value) as T) : null;
    } catch (error) {
      console.error('Error reading from localStorage: ', error);
      return null;
    }
  }

  public removeItem(key: string): void {
    if (!this.storage) {
      return;
    }

    try {
      this.storage.removeItem(key);
    } catch (error) {
      console.error('Error removing from localStorage: ', error);
    }
  }

  public clear(): void {
    if (!this.storage) {
      return;
    }

    try {
      this.storage.clear();
    } catch (error) {
      console.error('Error clearing localStorage: ', error);
    }
  }
}
